import { useCallback } from 'react';
import { useTranslation as useI18nextTranslation } from 'react-i18next';
// Ради побочного эффекта: без инициализированного i18next хук вернул бы вместо
// перевода сам ключ. Импорт стоит здесь, а не только в App, чтобы это было верно
// и для компонента, отрисованного в обход приложения, — например в тесте.
import '../i18n';

/**
 * Язык интерфейса живёт в i18next и больше нигде. Перерисовку после смены языка
 * делает сам react-i18next: `useTranslation` подписан на событие `languageChanged`
 * (опция `bindI18n`, включена по умолчанию). Сохранение выбора — на детекторе,
 * см. `i18n/index.js`.
 */
const useTranslation = () => {
    const { t, i18n } = useI18nextTranslation();

    const changeLanguage = useCallback((language) => i18n.changeLanguage(language), [i18n]);

    return {
        t,
        // `resolvedLanguage`, а не `language`: если код языка окажется незнакомым,
        // это тот язык, который человек видит на экране, а не тот, что запросили.
        currentLanguage: i18n.resolvedLanguage,
        changeLanguage,
    };
};

export default useTranslation;
